export default "__VITE_ASSET__OfVaJPeL__"